import { WellDetailCardData } from "api/data";

import { PanelField } from "../PanelField";
import { WELL_PARAMETER_FIELDS } from "../constants";
import { Block, SectionLabel, StatGrid } from "../styles";

export function WellParametersBlock({
  wellData
}: {
  wellData: Maybe<WellDetailCardData>;
}): JSX.Element {
  return (
    <Block $snow>
      <SectionLabel>Well Parameters</SectionLabel>
      <StatGrid $columns={5}>
        {WELL_PARAMETER_FIELDS.map((field) => (
          <PanelField
            key={field.property}
            propertyName={field.property}
            fallbackLabel={field.fallbackLabel}
            isBoolean={field.boolean}
            label={field.label}
            booleanText={field.booleanText}
            wellData={wellData}
          />
        ))}
      </StatGrid>
    </Block>
  );
}
